var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "btn-group btn-group-sm",
      attrs: { "aria-label": "datetime range dropdown", role: "group" },
    },
    [
      _c(
        "div",
        { attrs: { id: "vueDialBack" } },
        [
          _vm.dateRange
            ? _c("dial-back-input", {
                attrs: {
                  "date-range-handler": _vm.dateRangeHandler,
                  "is-back-disabled": !_vm.isMoveRangeBackwardEnabled,
                  "is-forward-disabled": !_vm.isMoveRangeForwardEnabled,
                  "is-live": _vm.isLive,
                  "is-paused": !_vm.isLive,
                  "date-range": _vm.dateRange,
                  "dial-back-hours": _vm.DIAL_BACK_HOURS,
                  "show-downsampling": _vm.showDownsampling,
                },
                on: { "media-button-pressed": _vm.mediaButtonHandler },
              })
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }